import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockGradeSelectorProps } from '@ts-blocks/block-grade-selector/interfaces'
import type { BlockHomepageTitleProps } from '@ts-blocks/block-homepage-title/interfaces'
import type { BlockStatsItemProps } from '@ts-blocks/block-stats-item/interfaces'
import type { SectionHeroGradeProps } from '@ts-sections/section-hero-grade/interfaces'
// hooks
import { useGlobalStats } from '@composables/tools/global-stats.hook'

type HeroGradeGradientColor = NonNullable<SectionHeroGradeProps['gradientColor']>

interface SectionHeroGradeHookOptions {
  section: () => SectionHeroGradeProps
}

interface SectionHeroGradeHookReturn {
  refTitle: ComputedRef<BlockHomepageTitleProps | null>
  refSubtitle: ComputedRef<string>
  refGradeSelector: ComputedRef<BlockGradeSelectorProps | null>
  refStats: ComputedRef<BlockStatsItemProps[]>
  refShowStats: ComputedRef<boolean>
  refGradientColor: ComputedRef<HeroGradeGradientColor>
}

export const useSectionHeroGrade = ({ section }: SectionHeroGradeHookOptions): SectionHeroGradeHookReturn => {
  const refGlobalStats = useGlobalStats()

  const refTitle = computed<BlockHomepageTitleProps | null>(() => section().title ?? null)

  const refSubtitle = computed<string>(() => section().subtitle ?? '')

  const refGradeSelector = computed<BlockGradeSelectorProps | null>(() => section().gradeSelector ?? null)

  const refStats = computed<BlockStatsItemProps[]>(() => {
    const stats = section().stats
    return stats?.useGlobalStats === false ? (stats.items ?? []) : refGlobalStats.value
  })

  const refShowStats = computed<boolean>(() => (
    section().showStatsBar !== false && refStats.value.length > 0
  ))

  const refGradientColor = computed<HeroGradeGradientColor>(() => (
    section().gradientColor ?? 'ultravioletPink'
  ))

  return {
    refTitle,
    refSubtitle,
    refGradeSelector,
    refStats,
    refShowStats,
    refGradientColor,
  }
}
